<template lang="pug">
b-modal#editPromoProvider(
  ref="editPromoProvider"
  :title="$t('ui.combine.edit_promo_provider_list')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.promotion_id')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="promotion_id"
        required
        type="text"
        :dirty="$v.promotion_id.$dirty"
        :error="$v.promotion_id.$error"
        v-model.trim.lazy="$v.promotion_id.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.promotion_id" :name="$t('ui.promotion_id')")
    b-form-group(:label="$t('ui.promotion_name')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="promotion_name"
        required
        type="text"
        :dirty="$v.promotion_name.$dirty"
        :error="$v.promotion_name.$error"
        v-model.trim.lazy="$v.promotion_name.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.promotion_name" :name="$t('ui.promotion_name')")
    b-form-group(:label="$t('ui.provider_list')" style="overflow: hidden scroll; height: 50vh;").mb-0
      table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
          tr
            th.text-center.col-checkbox(colspan=3)
              .d-flex
                .custom-checkbox.custom-control
                  input#all-provider.custom-control-input(type='checkbox' data-checkboxes="allSelected" data-checkbox-role="dad" @change="selectAll(0,$event)" v-model="allSelected[0]" :disabled="loading")
                  label.custom-control-label(for='all-provider') {{ $t('ui.all') }}
                template(v-for="(cat, index) in providerCatList")
                  .custom-checkbox.custom-control
                    input.custom-control-input(
                      type="checkbox"
                      :id="'all-' + cat.toLowerCase()"
                      v-model="allSelected[index + 1]"
                      @change="selectAll(index + 1,$event)"
                      :disabled="loading"
                    )
                    label.custom-control-label(:for="'all-' + cat.toLowerCase()") {{ $t('ui.' + cat.toLowerCase()) }}
                //- .custom-checkbox.custom-control
                //-   input#all-livecasino.custom-control-input(type='checkbox' data-checkboxes="allSelected1" data-checkbox-role="dad" @change="selectAll(1,$event)" v-model="allSelected1" :disabled="loading")
                //-   label.custom-control-label(for='all-livecasino') {{ $t('ui.livecasino') }}
                //- .custom-checkbox.custom-control
                //-   input#all-slots.custom-control-input(type='checkbox' data-checkboxes="allSelected2" data-checkbox-role="dad" @change="selectAll(2,$event)" v-model="allSelected2" :disabled="loading")
                //-   label.custom-control-label(for='all-slots') {{ $t('ui.slots') }}
                //- .custom-checkbox.custom-control
                //-   input#all-sportsbook.custom-control-input(type='checkbox' data-checkboxes="allSelected3" data-checkbox-role="dad" @change="selectAll(3,$event)" v-model="allSelected3" :disabled="loading")
                //-   label.custom-control-label(for='all-sportsbook') {{ $t('ui.sportsbook') }}
          tr(v-for='(p, index) in pList')
            td.text-center.col-checkbox(width="5%")
              .custom-checkbox.custom-control
                input.custom-control-input(:id="'all-' + index" type='checkbox' v-model="provider_list" :value='p.value' :disabled="loading")
                label.custom-control-label(:for="'all-' + index") &nbsp;
            td {{ p.text }}
      ValidateResult(:value="$v.provider_list" :name="$t('ui.provider_list')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const atLeastOneProvider = (value) => value.length > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      promotion_id: "",
      promotion_name: "",
      provider_list: [],
      providerList: [],
      allSelected: {},
      pList: [],
      providerCatList: [],
      prefixMap: {}
    };
  },
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    }
  },
  validations: {
    promotion_id: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    promotion_name: {
      required,
      // minLength: minLength(6),
      maxLength: maxLength(100)
    },
    provider_list: {
      atLeastOneProvider,
      minLength: minLength(1)
    },
  },
  watch: {
    provider_list: {
      handler(newValue) {
        const val = (newValue.length === this.pList.length && this.pList.length > 0)

        const checkGroupSelected = prefix => {
          const items = this.pList.filter(item => item.category === prefix)
          return items.length > 0 && items.every(item => newValue.includes(item.value))
        }
        // console.log(this.allSelected)

        Object.keys(this.allSelected).forEach(k => {
          const num = Number(k)

          // master
          if (num === 0) {
            this.$set(this.allSelected, 0, val)
          }
          // others
          else {
            this.$set(this.allSelected, num, checkGroupSelected(this.providerCatList[num-1]))
          }
        })
      },
      deep: true
    }
  },
  methods: {
    selectAll: function(mode, evt) {
      const prefixMap = this.prefixMap

      // If mode is 0 (master checkbox toggled), sync all individual selections
      if (mode === 0) {
        Object.keys(this.allSelected).forEach(k => {
          this.$set(this.allSelected, k, evt.target.checked)
        })

        if (!this.allSelected[0]) {
          this.provider_list = [];
          return; // Exit early if unchecking all
        }

        // Select all providers with matching prefixes
        const allPrefixes = Object.values(prefixMap);
        this.provider_list = this.pList
          .filter(item => allPrefixes.some(prefix => item.category == prefix))
          .map(item => item.value);

        return;
      }

      const checked = evt.target.checked
      this.$set(this.allSelected, mode, checked)

      // Individual group checkbox toggled
      const prefix = prefixMap[mode];
      const groupItems = this.pList.filter(item => item.category == prefix);
      const groupValues = groupItems.map(item => item.value);

      if (this.allSelected[mode]) {
        // Add group values to provider_list without duplicates
        this.provider_list = Array.from(new Set([...this.provider_list, ...groupValues]));
      } else {
        // Remove only group values
        this.provider_list = this.provider_list.filter(val => !groupValues.includes(val));
      }
    },
    removeDuplicate(arr) {
      let s = new Set(arr);
      let it = s.values();
      return Array.from(it);
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.promotionUpdateProviderUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          promotion_id: this.promotion_id
        };

        if (this.provider_list.length != this.pList.length)
          json.provider_list = this.removeDuplicate(this.provider_list.sort()).toString();

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editPromoProvider.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_promo_provider_list", this.feedback.status);
                  this.$refs.editPromoProvider.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function() {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    getProviderList: function() {
      let url = config.providerMaintenanceOperatorListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        is_free: false,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                let list = (response.data.dt || []).filter(item => item.aggregator !== "GTA");
                if(list.length > 0) {
                  this.providerList = (response.data.dt || []).filter(item => item.aggregator !== "GTA");
                  this.setCategory();
                  this.getPList();
                } else {
                  this.providerList = [];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setCategory() {
      // Build unique category list using Set (avoid duplicates)
      const catsSet = new Set()
      for (const item of this.providerList) {
        // add each category into Set (Set auto removes duplicates)
        catsSet.add(item.category)
      }

      // convert Set back to Array so we can use v-for easily
      this.providerCatList = Array.from(catsSet)

      // create checkbox state object
      // key 0 = master "select all" checkbox (initially false = unchecked)
      const obj = { 0: false }

      // for each category index, set initial checkbox state for that group also false
      this.providerCatList.forEach((_, i) => {
        obj[i + 1] = false  // i+1 means group number starting from 1
      })

      this.allSelected = obj

      this.prefixMap = this.providerCatList.reduce((o, v, idx) => {
        o[idx + 1] = v
        return o
      }, {})
    },
    getPList() {
      let list = this.providerList;

      let result = [];

      for(var i = 0; i < list.length; i++) {
        result.push({value: list[i].provider_code, text: list[i].provider_name, checked: false, category: list[i].category});
      }
      this.pList = result;

      this.initialProviderCheckbox();
    },
    initialProviderCheckbox() {
      if (this.item.provider_list != null) {
        var arr = this.item.provider_list.split(',');
        // Get all valid provider codes from pList
        const validProviderCodes = this.pList.map(p => p.value);

        for(var i = 0; i < arr.length; i++) {
          // Only add provider codes that exist in the current pList
          if (validProviderCodes.includes(arr[i])) {
            this.provider_list.push(arr[i]);
          }
        }
      }
      else {
        this.allSelected[0] = true;
        var arr = this.pList;
        for(var i = 0; i < arr.length; i++) {
          this.provider_list.push(arr[i].value);
        }
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.providerList = [];
      this.pList = [];
      this.allSelected = {};
      this.providerCatList = [];
      this.prefixMap = {};
      this.$set(this.allSelected, 0, false)
      this.promotion_id = this.item.promotion_id;
      this.promotion_name = this.item.promotion_name;
      // this.provider_list = this.item.provider_list != null ? this.item.provider_list.toUpperCase().split(',') : [];
      this.provider_list = [];
      this.getProviderList();
    }
  }
};
</script>
